export default "__VITE_ASSET__Usxxy1qx__"